import { render, staticRenderFns } from "./TitleDetailHeroV1.vue?vue&type=template&id=bc2231a8&scoped=true"
import script from "./TitleDetailHeroV1.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleDetailHeroV1.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleDetailHeroV1.vue?vue&type=style&index=0&id=bc2231a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2231a8",
  null
  
)

export default component.exports